"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScreenDPI = void 0;
var _once = _interopRequireDefault(require("lodash/once"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getScreenDPI = exports.getScreenDPI = (0, _once["default"])(function () {
  var d = document.createElement('div');
  d.style.width = '1cm';
  document.body.appendChild(d);
  var r = d.getBoundingClientRect().width;
  document.body.removeChild(d);
  return r;
});